const cache = new Map();
const lifetime = 30000;
export const clearQuotationListCache = () => cache.clear();
export function cachedQuotationList(scope) {
  const entry = cache.get(scope);
  return entry && Date.now() - entry.savedAt < lifetime ? entry.rows : null;
}
export async function loadQuotationList(api, { scope, signal, onProgress }) {
  const { data } = await api.get('client/freelance', { signal });
  const clients = Array.from(new Map((Array.isArray(data) ? data : []).map(client => [client._id, client])).values());
  const rows = [];
  let cursor = 0;
  let completed = 0;
  let failures = 0;
  await Promise.all(Array.from({ length: Math.min(6, clients.length) }, async () => {
    while (!signal.aborted && cursor < clients.length) {
      const client = clients[cursor++];
      try {
        const { data: quotations } = await api.get(`quotation/by-client/${client._id}`, { signal });
        if (!Array.isArray(quotations)) throw new Error('Invalid quotation list');
        quotations.forEach(quotation => rows.push({quotation, client}));
      } catch (error) {
        if (signal.aborted) return;
        failures++;
      }
      if (signal.aborted) return;
      completed++;
      onProgress({rows: [...rows], completed, total: clients.length});
    }
  }));
  if (signal.aborted) return null;
  rows.sort((a,b) => (new Date(b.quotation.createdAt).getTime() || 0) - (new Date(a.quotation.createdAt).getTime() || 0));
  if (!failures) cache.set(scope, {rows, savedAt:Date.now()});
  return {rows, failures};
}
